import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {NewsAnnouncement} from '../main/news-announcement';

@Service()
export class NewsAnnouncementService {
  private readonly http = inject(HttpClient);


  private urlBase = environment.serviceUrl;

  public getActiveAnnouncements(): Observable<NewsAnnouncement[]> {
    let url = this.urlBase + 'newsAnnouncement/active';
    return this.http.get<NewsAnnouncement[]>(url);
  }

}
